module.exports = "/assets/data/482b794abeff4edf7680dc57209b3cbb-G1.data.json";